import { Component, OnInit } from '@angular/core';
import {HeaderService} from "../../../../../services/header/header.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-bon-transfert',
  templateUrl: './bon-transfert.component.html',
  styleUrls: ['./bon-transfert.component.scss']
})
export class BonTransfertComponent implements OnInit {


    constructor(private headerService: HeaderService, private router : Router) { }
    searchText = '';
    currentPage = 1;


    items  = [
        {
            reference: 'BS-0009',
            date: '10/04/2025',
            clientName: 'Aymen',
            totalTTC: '300,600 TND',
            totalTTCNoSpace: '300,600TND',
            status: 'Créé'
        },
        {
            reference: 'BS-0009',
            date: '10/04/2025',
            clientName: 'Aymen',
            totalTTC: '300,600 TND',
            totalTTCNoSpace: '300,600TND',
            status: 'Valide'
        },

        {
            reference: 'BS-0009',
            date: '10/04/2025',
            clientName: 'Aymen',
            totalTTC: '300,600 TND',
            totalTTCNoSpace: '300,600TND',
            status: 'Créé'
        },
        {
            reference: 'BS-0009',
            date: '10/04/2025',
            clientName: 'Aymen',
            totalTTC: '300,600 TND',
            totalTTCNoSpace: '300,600TND',
            status: 'Créé'
        },
        {
            reference: 'BS-0009',
            date: '10/04/2025',
            clientName: 'Aymen',
            clientEmail: 'Layne_Kuvalis@gmail.com',
            totalTTC: '300,600 TND',
            totalTTCNoSpace: '300,600TND',
            status: 'Annulé'
        },
        {
            reference: 'BS-0009',
            date: '10/04/2025',
            clientName: 'Aymen',
            totalTTC: '300,600 TND',
            totalTTCNoSpace: '300,600TND',
            status: 'Valide'
        }
    ];
    selectedStatus: string = 'Tous';
    filteredItems: any[] = [];
    showFilter = false;
    filters = {
        client: '',
        projet: '',
        montant: '',
        etat: '',
        point_vente: ''
    };
    ngOnInit(): void {

        this.headerService.setConfig({
            title: 'Bon de transfert',
            buttons: [
                {
                    label: 'Exporter',
                    action: () => this.exportData(),
                    type: 'secondary'
                }
            ]
        });


    }

    exportData() {
        console.log('Exporting data...');
    }
}
